import {
  getAllUserRouteStatus,
  recalculateScore,
  UserClimbingEvent,
  UserClimbingRoute,
  UserRouteStatus
} from "../../../../models/UserClimbingEvent";
import {ClimbingEvent} from "../../../../models/ClimbingEvent";
import React, {FC, useState} from "react";
import {Box} from "@mui/system";
import {Button, TextField} from "@mui/material";

type Props = {
  userEvent: UserClimbingEvent,
  event: ClimbingEvent,
  updateUserData: (userEvent: UserClimbingEvent) => void
}
export const EditUserRoutes: FC<Props> = ({userEvent, event, updateUserData}) => {

  const [routes, setRoutes] = useState<Map<UserRouteStatus, string[]>>(userEvent.climbingRoutes.reduce((acc, r) => {
    if (acc.has(r.status)) {
      acc.get(r.status)?.push(r.id.toString())
    } else {
      acc.set(r.status, [r.id.toString()])
    }
    return acc;
  }, new Map<UserRouteStatus, string[]>()))

  const onClick = () => {
    const ucr: UserClimbingRoute[] = []

    routes.forEach((routes, status) => {
      if (status !== UserRouteStatus.NOTHING) {
        const routesAsObjects = routes.map((r) => parseInt(r)).filter((r) => !isNaN(r)).map((id) => ({id: id, status}));
        routesAsObjects.forEach(r => {
          if (!ucr.find((ucr) => ucr.id === r.id)) {
            ucr.push(r)
          }
        })
      }
    });
    const newUserEvent = {...userEvent, climbingRoutes: ucr}
    recalculateScore(newUserEvent, event)
    updateUserData(newUserEvent)
  }

  return (
    <Box display={'flex'} flexDirection={'column'} gap={2}>
      {getAllUserRouteStatus(event).filter(s=>s.status!==UserRouteStatus.NOTHING).map((s) => {
        return (
          <TextField
            label={s.status}
            value={routes.get(s.status)?.join(",")}
            onChange={(e) => {
              setRoutes(new Map(routes.set(s.status, e.target.value.split(","))))
            }}
          />
        )
      })
      }
      <Button onClick={() => {
        onClick()
      }}>Zapisz</Button>
    </Box>
  )
}